<template>
	<div>
		<div class="score-info">
			<div class="live-scores">
				<div class="live-scores-title" style="cursor: pointer;" @click='holebyholeLive(progressCompetition)'>
					<div v-show="lang === 'zh-CN'?true:false">比分直播</div>
					<div v-show="lang === 'en'?true:false">Live score</div>
					<div v-if="progressCompetition != null">{{progressCompetition.staName}}</div>
				</div>
				<div v-if="progressCompetition != null" class="scores">
					<i class="el-icon-arrow-left" v-if="scoreList.length === 0 ?false:true" @click="scrollLeft"></i>

					<div id="score-box" class="score-box">
						<div id="score-list" class="score-list">
							<div class="item" v-for="(item, index) in scoreList" :key="index">
								<div class="ranking">{{ item.rankShow }}</div>
								<div class="name playerName">{{ item.playerName }}</div>
								<div class="doll">{{ item.totalaba }}</div>
								<div class="score">{{ item.holes }}</div>
							</div>
						</div>
					</div>

					<i class="el-icon-arrow-right" v-if="scoreList.length === 0 ?false:true" @click="scrollRight"></i>
				</div>
			</div>
			<div class="hr" />

			<div class="ongoing-events flex-row">
				<div class="rotation">
					<el-carousel :interval="5000" arrow="always" height="405px" indicator-position="none">
						<el-carousel-item v-for="(item, index) in bannerList" :key="index">
							<img referrerpolicy="no-referrer" :src="item.imageUrl" class="banner"
								@click="handleBannerDetail(item)">
							<div class="banner-title" v-show="item.title != ''?true:false"
								@click="handleBannerDetail(item)">{{item.title}}</div>
							<div v-show="item.title === ''?true:false"></div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="recent-events">
					<div class="type justify-evenly" style="margin-bottom: 10px;"  v-show="lang === 'zh-CN'?true:false">
						<div class="item-status" v-for="(item, index) in allEventStatus" :key="index"
							@click="changeEventType(item)">
							<el-button v-if="item.gameState == 'O'" type="primary" :disabled="!isProgress"
								@click="clickCompetitionInfo(item.gameState)">正在进行</el-button>
							<el-button v-if="item.gameState == 'C'" type="primary" :disabled="!isEnd"
								@click="clickCompetitionInfo(item.gameState)">已经结束</el-button>
							<el-button v-if="item.gameState == 'N'" type="primary" :disabled="!isNotStarted"
								@click="clickCompetitionInfo(item.gameState)">即将开赛</el-button>
						</div>
					</div>
							  <div class="type justify-evenly" style="margin-bottom: 10px;" v-show="lang === 'en'?true:false">
		    <div class="item-status" v-for="(item, index) in allEventStatus" :key="index"
		      @click="changeEventType(item)">
		      <el-button v-if="item.gameState == 'O'" type="primary" :disabled="!isProgress" @click="clickCompetitionInfo(item.gameState)">Current</el-button>
		      <el-button v-if="item.gameState == 'C'" type="primary" :disabled="!isEnd"  @click="clickCompetitionInfo(item.gameState)">Last</el-button>
		      <el-button v-if="item.gameState == 'N'" type="primary" :disabled="!isNotStarted"  @click="clickCompetitionInfo(item.gameState)">Next</el-button>
		    </div>
		  </div>

					<div v-if="competition != null" >
						<div class="info flex-col" v-show="lang === 'zh-CN'?true:false">
							<template>
								<!-- <span>已经结束</span> -->
								<span v-if="competition.gameState == 'O'">正在进行</span>
								<span v-if="competition.gameState == 'C'">已经结束</span>
								<span v-if="competition.gameState == 'N'">即将开赛</span>
							</template>

							<span @click="staNameBtn(competition)">{{ competition.staName }}</span>
							<span>{{ competition.beginTime }}-{{ competition.endTime }}</span>
							<span>奖金¥{{ competition.bonusNum }}</span>
						</div>
						<div class="info flex-col" v-show="lang === 'en'?true:false">
							<template>
								<span v-if="competition.gameState == 'O'">Current</span>
								<span v-if="competition.gameState == 'C'">Last</span>
								<span v-if="competition.gameState == 'N'">Next</span>
							</template>

							<span @click="staNameBtn(competition)">{{ competition.staName }}</span>
							<span>{{ competition.beginTime }}-{{ competition.endTime }}</span>
							<span>Bonus¥{{ competition.bonusNum }}</span>
						</div>
					</div>
			<!-- 		<div class="detail">
						<div class="item-detail" style="cursor:pointer" @click="totalPoints">总成绩</div>
						<div class="item-detail" style="cursor:pointer" @click='kickoffTime'>开球时间</div>
						<div class="item-detail" style="cursor:pointer" @click="holebyholeScore">逐洞成绩</div>
						<div class="item-detail" style="cursor:pointer" @click='meanValue'>平均数据统计</div>
						<div class="item-detail" style="cursor:pointer" @click="playerRoster">球员名单</div>
						<div class="item-detail" style="cursor:pointer" @click='information'>赛事服务信息</div>
					</div> -->
					   <div class="detail" v-show="lang === 'zh-CN'?true:false">
            <div class="item-detail" style="cursor:pointer" @click="totalPoints">总成绩</div>
            <div class="item-detail" style="cursor:pointer" @click='kickoffTime'>开球时间</div>
            <div class="item-detail" style="cursor:pointer" @click="holebyholeScore">逐洞成绩</div>
            <div class="item-detail" style="cursor:pointer" @click='meanValue'>平均数据统计</div>
            <div class="item-detail" style="cursor:pointer" @click="playerRoster">球员名单</div>
            <div class="item-detail" style="cursor:pointer" @click='information'>赛事服务信息</div>
          </div>
		  <div class="detail" v-show="lang === 'en'?true:false">
		    <div class="item-detail" style="cursor:pointer" @click="totalPoints">Tournaments</div>
		    <div class="item-detail" style="cursor:pointer" @click='kickoffTime'>Tee Times</div>
		    <div class="item-detail" style="cursor:pointer" @click="holebyholeScore">Hole BY Hole</div>
		    <div class="item-detail" style="cursor:pointer" @click='meanValue'>Course STATS</div>
		    <div class="item-detail" style="cursor:pointer" @click="playerRoster">FIELD</div>
		    <div class="item-detail" style="cursor:pointer" @click='information'>Tournament Service</div>
		  </div>
					<div>
						<div class="schedule yellow flex-row justify-center" v-for="item in buttonList" :key="item.id" style="cursor: pointer;" @click="groupBtn(item.linkUrl)">

							<span class="text-group" >{{item.title}}</span>
						</div>
					</div>
				</div>

			</div>

		</div>
		<div class="bonus-list flex-row">
			<div class="bonus">
				<div class="bonus-link justify-between">
					<div>
						<img referrerpolicy="no-referrer"
							src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps287xybggyn5e5oppqjhc1tsm561ui2ujd2971c5d-28a8-47b2-a8e9-0ffa751ea0b9" />
						<span class="title" v-show="lang ==='zh-CN'?true:false">{{gameSeason}}积分榜</span>
						<span class="title" v-show="lang ==='en'?true:false">{{gameSeason}}Points</span>
					</div>
					<div>
						<span class="more" v-show="lang === 'zh-CN'?true:false"  @click="leaderBoard">更多</span>
						<span class="more" v-show="lang === 'en'?true:false"  @click="leaderBoard">More</span>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="winners justify-between">
					<div class="winnerList">
						<div class="top-five" v-for="(item, index) in winnerList" :key="index"
							@mouseover="handleHover(item, index)" @click="handleHoverBtn">
							<div class="item-winner flex-row" :class="winnerActive == index ? 'active' : 'normal'">
								<span class="ranking" v-if="winnerList.length>0">{{ item.bonusRankShow }}</span>
								<img class="avatar" v-if="winnerList.length>0" referrerpolicy="no-referrer"
									:src="item.photo" />
								<div class="info">
									<div>
										<span class="name" style="font-size: 12px;"
											v-if="winnerList.length>0">{{ item.plName}}</span>
										<img v-if="item.nation && winnerList.length>0"
											:src="require('@/assets/imgs/country/' + item.nation + '.png')" width="18"
											height="18" style="margin-bottom: -3px; margin-left: 5px;" />
									</div>
									<div>
										<span class="money"
											v-if="winnerList.length>0">{{ item.points.toFixed(2) }}</span>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div class="winnerNo"
						v-show="winnerList.length === 0 ? true:false">
						<div style="font-size: 16px;color: darkgray;">暂无数据</div>
					</div>
					<div class="tooltip-content" style="margin: auto;" v-show="winnerList.length === 0 ? false:true">
						<img :src="hoverInfo.photo" alt="" width="100%" v-if="hoverInfo!=undefined" />
						<div>
							<div style="display: flex;align-items: center;">
								<h4 style="color: #062D4F;padding-right: 10px;">{{hoverInfo.plName}}</h4>
								<img v-if="hoverInfo.nation && winnerList.length>0"
									:src="require('@/assets/imgs/country/' + hoverInfo.nation + '.png')" width="30"
									height="30" />
							</div>

							<div class="item-tooltip justify-between " v-if="hoverInfo!=undefined">
								<div class="content-text flex-row justify-between ">
									<img class="icon" referrerpolicy="no-referrer"
										src="https://lanhu.oss-cn-beijing.aliyuncs.com/psugzxwfgd0vbbdkr0zqdlqgejcxqf20o5236d6f0-faab-4cdb-a440-96f58bb742d5"
										width="24" height="24" style="margin-top: 2px;" />
									<span class="rank" v-show="lang ==='zh-CN'?true:false">积分排名</span>
									<span class="rank" v-show="lang ==='en'?true:false">Points Ranking</span>
									
									
								</div>
								<div class="img-rank flex-col">
									<span class="img-text">{{ hoverInfo.pointsRankShow }}</span>
								</div>
							</div>

							<div class="item-tooltip justify-between align-center" v-if="hoverInfo!=undefined">
								<div class="content-text flex-row justify-between ">
									<img class="icon" referrerpolicy="no-referrer"
										src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps13msnoaac23flqk24oi5fs60schxni63c08950a-7545-4eab-b177-30a883346b45" />
									<span class="rank" v-show="lang ==='zh-CN'?true:false">平均杆数</span>
									<span class="rank" v-show="lang ==='en'?true:false">SCORING AVERAGE</span>
								</div>
								<span class="average-rods">{{ hoverInfo.avgScore }}</span>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="news">
				<div class="news-link justify-between">
					<span class="title" v-show="lang === 'zh-CN'?true:false">热点要闻</span>
					<span class="title" v-show="lang === 'en'?true:false">Hot News</span>
					<div @click="handleNews">
						<span class="more" v-show="lang === 'zh-CN'?true:false">更多</span>
						<span class="more" v-show="lang === 'en'?true:false">More</span>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="news-info">
					<el-scrollbar style="height: 360px" wrap-style="overflow-x:hidden;">
						<span class="item-news text-ellipsis1" v-for="(item, index) in allNews" :key="index"
							@click="handleNewsDetail(item)">
							{{ item.title }}
						</span>
					</el-scrollbar>
		<!-- 			<div class="pagination justify-around">
						<pagination v-show="totalCount > 0" :total="totalCount" layout="prev, next"
							:page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
							@pagination="getNewsList" />
					</div> -->

				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		bonusLeaderboardApi,
		contentsListApi,
		gamestationInfo,
		indexScore,
		contentsListInfoApi,
		pointsList
	} from '@/api/user/index.js'
	//内容类型:1轮播图、2、按钮 3、官方战略合作伙伴、4巡回赛赞助商、5、承办球场 6、联合认证赛事 7、合作单位 8、合作媒体 11、热点新闻
	const ContentType = {
		"Banner": 1,
		"Button": 2,
		"Partner": 3,
		"Sponsors": 4,
		"Court": 5,
		"Competition": 6,
		"Unit": 7,
		"Media": 8,
		"HotNews": 11
	}

	//  比赛状态 C-已结束  O-进行中 N-未开始
	const CompetitionState = {
		"End": "C",
		"Progress": "O",
		"NotStarted": "N"
	}

	export default {
		name: "HomePage",
		components: {},
		data() {
			return {
				winnerList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,

				},
				totalCount: 0, // 新闻总数
				// 赛事状态
				allEventStatus: [{
						gameState: "O",
					},
					{
						gameState: "C",
					},
					{
						gameState: "N",
					}
				],
				activeName: 'first',
				activeIndex: '1',
				dialogVisible: false,
				scoreList: [],

				winnerActive: 0,
				hoverInfo: {},
				paginationInfo: [{
						name: '上一页',
						status: 'prev'
					},
					{
						name: '下一页',
						status: 'next'
					},
				],
				pageNumber: 0,
				allNews: [],

				// banner
				bannerList: [],

				// 比分赛事
				progressCompetition: null,

				// 赛事信息
				competition: null,

				isProgress: true, // 赛事进行中
				isEnd: true, // 赛事结束
				isNotStarted: true, // 未开始

				winnerShow: false,
				winnerNo: true,
				buttonList: [],
				eventId: '',
				gameState: '',
				gameSeason: "",
				lang: 'zh-CN'
			};
		},
		// created() {
		//   // this.totalCount = this.allNews.length
		// },
		created() {
			this.getBannerList()
			this.getNewsList()
			this.getAllCompetitionInfo(CompetitionState.Progress)
			this.buttonSwitch()
			this.bonusLeaderboard()
			this.getScore()
			this.lang = localStorage.getItem('language')
			if(this.lang === null){
				this.lang = 'zh-CN'
			} else {
				this.lang = localStorage.getItem('language')	
			}
		},

		methods: {
			//总成绩
			totalPoints() {
				localStorage.setItem('id', this.eventId)

				this.$router.push({
					path: "/totalScore",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//开球时间
			kickoffTime() {
				localStorage.setItem('id', this.eventId)

				this.$router.push({
					path: "/teeTime",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//逐洞成绩
			holebyholeScore() {
				localStorage.setItem('id', this.eventId)
				this.$router.push({
					path: "/holeResult",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//平均数据统计
			meanValue() {
				localStorage.setItem('id', this.eventId)

				this.$router.push({
					path: "/averageData",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//球员名单
			playerRoster() {
				localStorage.setItem('id', this.eventId)
				this.$router.push({
					path: "/roster",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//赛事服务信息
			information() {
				localStorage.setItem('id', this.eventId)

				this.$router.push({
					path: "/eventServiceInfo",
					query: {
						id: this.eventId,
						// gamestate:this.gameState
					}
				})
			},
			//内容列表
			getList() {
				const data = {
					contentId: 1
				}
				contentsListApi(data).then(res => {
					
				})
			},

			// bannerList
			getBannerList() {
				const data = {
					contentId: ContentType.Banner
				}
				contentsListApi(data).then(res => {
					this.bannerList = res.data.data
					
					
				})
			},

			// 请求所有赛事信息
			getAllCompetitionInfo(gameState) {
				const params = {
					gameState: gameState
				}
				gamestationInfo(params).then(res => {
					const data = res.data.data
					if (gameState === CompetitionState.Progress) {
						this.isProgress = data != null
					} else if (gameState === CompetitionState.End) {
						this.isEnd = data != null
					} else {
						this.isNotStarted = data != null
					}
					if (data) {
						this.competition = data
						
						this.eventId = data.id
						this.gameState = data.gameState
					} else {
						if (gameState === CompetitionState.Progress) {
							this.getAllCompetitionInfo(CompetitionState.End)
						} else if (gameState === CompetitionState.End) {
							this.getAllCompetitionInfo(CompetitionState.NotStarted)
						} else {

						}
					}
				})
			},

			// 赛事信息
			getCompetitionInfo(gameState) {
				const data = {
					gameState: gameState
				}
				gamestationInfo(data).then(res => {

					const data = res.data.data
					if (gameState === CompetitionState.Progress) {
						this.isProgress = data != null
					} else if (gameState === CompetitionState.End) {
						this.isEnd = data != null
					} else {
						this.isNotStarted = data != null
					}
					this.competition = data

					if (data) {
						this.eventId = data.id
						this.gameState = data.gameState
					}
				})
			},
			// 赛事状态
			clickCompetitionInfo(gameState) {

				this.getCompetitionInfo(gameState)
			},

			//按钮
			buttonSwitch() {
				const data = {
					contentId: 2
				}
				contentsListApi(data).then(res => {
					this.buttonList = res.data.data
				})
			},
			//跳转
			groupBtn(row) {
				window.open(row,'_blank')
			},
			// 热点要闻
			getNewsList() {
				const data = {
					pageNum: this.queryParams.pageNum,
					pageSize: this.queryParams.pageSize,
					contentId: ContentType.HotNews
				}
				contentsListInfoApi(data).then(res => {
					this.totalCount = res.data.total
					this.allNews = res.data.rows
					
					
				})
			},

			// 比分
			getScore() {
				indexScore().then(res => {	
					this.scoreList = res.data.data.playerscoreList
					this.progressCompetition = res.data.data
					console.log(this.progressCompetition)
				})
			},

			handleNews() {
				this.$router.push({
					path: '/news'
				})
			},
			handleNewsDetail(item) {
				
				if (item.type == 0) {
					window.open(item.linkUrl, '_blank')
				} else {
					this.$router.push({
						path: '/newsDetail',
						query: {
							id: item.id,
						}
					})
				}
				/* this.$router.push({
				  path: '/newsDetail',
				  query: {
				    id: item.id
				  }
				}) */
			},

			handleBannerDetail(item) {
				if (item.type === '0') {
					
					window.location.href = item.linkUrl
				} else if (item.type === '1') {
					this.$router.push({
						path: '/bannerDetail',
						query: {
							id: item.id
						}
					})
				}
			},
			handlePagination(item, index) {
				this.pageNumber = index;
			},
			handlePagination(item, index) {

				this.pageNumber = index;
			},
			handleHover(item, index) {
				this.winnerActive = index
				this.hoverInfo = item

			},
			handleHoverBtn(){
				this.$router.push({
					path:'/points'
				})
			},

			changeEventType(val) {
				
			},



			// 左滑动逻辑
			scrollLeft() {
				const allLength = this.scoreList.length * 200
				const width = 600
				const boxLength = document.getElementById('score-box').clientWidth
				if (allLength < boxLength) return
				const listEl = document.getElementById('score-list')
				const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null).left))
				if (leftMove + boxLength - width < boxLength) {
					// 到最开始的时候
					listEl.style.left = '0px'
				} else {
					listEl.style.left = '-' + (leftMove - width) + 'px'
				}
			},

			// 右滑动逻辑
			scrollRight() {
				const allLength = this.scoreList.length * 200
				const width = 600

				const boxLength = document.getElementById('score-box').clientWidth
				if (allLength < boxLength) return
				const listEl = document.getElementById('score-list')
				const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null).left))
				if (leftMove + boxLength + width > allLength) {
					listEl.style.left = '-' + (allLength - boxLength) + 'px'
				} else {
					listEl.style.left = '-' + (leftMove + width) + 'px'
				}
			},
			//奖金榜
			bonusLeaderboard() {

				// bonusLeaderboardApi().then(res => {
				// 	this.winnerList = res.data.data.bonusList
				// 	this.hoverInfo = res.data.data.bonusList[0]
					
				// 	this.gameSeason = res.data.data.gameSeason
				
				// })
				pointsList().then(res=>{
					this.winnerList = res.data.data.pointsList
					this.hoverInfo = res.data.data.pointsList[0]
					
					this.gameSeason = res.data.data.gameSeason
				})
			},

			//奖金榜更多
			leaderBoard() {
				this.$router.push({
					path: '/points'
				})
			},
			staNameBtn(row) {
				localStorage.setItem('id', row.id)
				this.$router.push({
					path: '/scheduleInfo',

				})
			},
			//比分直播
			holebyholeLive(row) {
				localStorage.setItem('id', row.id)
				localStorage.setItem('gameType', row.gameType)
				this.$router.push({
					path: "/holeResult",
					query: {
						id: row.id,
						lang:this.lang
					}
				})
			}
		}
	};
</script>
<style lang="scss" scoped>
	.score-info {
		background-color: #fff;
	}
	
	.live-scores {
		height: 65px;
		padding: 0 17px;
		display: flex;
		align-items: center;
		font-size: 13px;

		// &-title {
	

		
		// }

		.scores {
			display: flex;
			// margin-left: 10px;
			width: calc(90% - 113px);
			margin-left: 20px;
			i {
				font-size: 30px;
				color: #3B7544;
				font-weight: 600;
				cursor: pointer;
				padding-top: 2%;
				height: 60px;
			}

			.score-box {
				overflow: hidden;

				.score-list {
					display: flex;
					transform: all 2s;

					.item {
						display: flex;
						align-items: center;
						padding-right: 15px;
						flex: 0 0 auto;
						width: 170px;
						height: 60px;
					}

					position: relative;
					left: 0;
					transition: left 1s;


					.item:not(:last-child) {
						border-right: 1px solid #ccc;
					}

					.ranking {
						font-size: 14px;
						color: #000000;
						margin: 0 10px;
					}

					.score,
					.name {
						color: #666666;
					}

					.playerName {
						width: 52%;
						word-break: break-all;
						font-size: 10px;
						line-height: 1;
						text-align: center;
						font-size: 14px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 3;
						overflow: hidden;
					}


					.doll {
						color: #D34747;
						font-size: 14px;
						margin: 0 12px;
					}
				}
			}
		}

	}
	.live-scores-title{
			display: inline-block;
			width: 600px;
			
	}
	.banner {
		width: 100%;
		height: 100%;
		object-fit: cover;
		cursor: pointer;
		position: absolute;
	}

	.banner-title {

		width: 100%;

		line-height: 25px;
		font-size: 18px;
		color: #fff;
		margin: 0 auto;
		text-align: center;
		position: fixed;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		cursor: pointer;
		word-break: break-all;
		word-wrap: break-word;
		white-space: pre-wrap;
		word-wrap: break-word;
		padding: 10px 0;
	}

	.hr {
		border-bottom: 3px solid #F5BB51;
		width: 97%;
		margin: 0 auto;
	}

	.ongoing-events {
		padding: 20px 18px;
		font-size: 14px;

		.rotation {
			width: 755px;
		}

		.recent-events {
			padding-left: 100px;
			.type {

				.item-status {
					overflow-wrap: break-word;
					color: rgba(255, 255, 255, 1);
					font-size: 16px;
					font-family: MicrosoftYaHei;
					text-align: left;
					white-space: nowrap;
					border-radius: 4px;
					padding: 8px 0;
					text-align: center;
					margin-right: 10px;
					cursor: pointer;

					.el-button.el-button--primary {
						background-color: #3b7544 !important;
						border: none !important;
					}

					.el-button--primary.is-disabled,
					.el-button--primary.is-disabled:hover {
						background-color: #3b7544 !important;
						opacity: 0.6 !important;
					}


				}
			}

			.info {
				margin: 6px 0;
			}

			.info span:nth-child(2) {
				font-size: 18px;
				font-weight: 400;
				cursor: pointer;
			}

			.info span:nth-child(3) {
				color: #999999;
				font-size: 14px;
			}

			.info span:nth-child(4) {
				color: #ECBD63;
				font-size: 16px;
			}

			.detail {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				grid-gap: 10px;

				.item-detail {
					display: inline-block;
					background-color: rgba(59, 117, 68, 1);
					border-radius: 4px;
					padding: 8px 0;
					width: 205px;
					color: #FFFFFF;
					text-align: center;
					font-size: 14px;
				}
			}

			.schedule {
				width: 100%;
				overflow-wrap: break-word;
				color: rgba(255, 255, 255, 1);
				font-size: 14px;
				font-family: MicrosoftYaHei;
				text-align: center;
				white-space: nowrap;
				padding: 10px 0;
				margin: 10px 0;
				border-radius: 4px;
			}
		}
	}

	.bonus-list,
	.partners {
		background-color: #fff;
		margin-top: 20px;
		padding: 20px 18px;

	}

	.bonus {
		width: 845px;

		.bonus-link {
			border-bottom: 3px solid #F5BB51;
			padding: 8px 0;

			.title {
				font-size: 18px;
				cursor: pointer;
			}

			.more {
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				cursor: pointer;
			}
		}
	}

	.winners {
		padding-top: 20px;
		padding-right: 12%;

		.winnerList {
			.active {
				width: 325px;
				height: 68px;
				// background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps1o44g9ofmegos47zbwzbfiq3jyl19l0wc6a7a8b4d-749d-4c20-913b-1c32cceb34b8) 100% no-repeat;
				background: url('../../assets/imgs/active-bg.png') no-repeat center left / 100%;
				// background-size: 100% 100%;
				transition: 0.3s;

				.ranking,
				.name,
				.money {
					color: rgba(255, 255, 255, 1);
				}

			}

			.normal {
				width: 300px;
				height: 80px;
				border-radius: 4px;
				background: #F7F7F7;

				.ranking,
				.name {
					color: #000;
				}

				.money {
					color: #ECBD63;
				}
			}

			.item-winner {
				cursor: pointer;
				margin-bottom: 15px;
			}

			.top-five {
				width: 50%;
			}

			.ranking {
				width: 8px;
				height: 15px;
				overflow-wrap: break-word;
				font-size: 18px;
				font-family: MicrosoftYaHei;
				text-align: left;
				white-space: nowrap;
				line-height: 18px;
				margin: 27px 0 0 16px;
			}

			.info {
				width: 200px;
				overflow-wrap: break-word;
				font-size: 0;
				font-family: MicrosoftYaHei;
				font-weight: NaN;
				text-align: left;
				margin: 15px 0 0 12px;
				position: relative;

				.name {
					width: 99px;
					height: 39px;
					overflow-wrap: break-word;
					font-size: 16px;
					font-family: MicrosoftYaHei;
					text-align: left;
					line-height: 24px;
				}

				.money {
					overflow-wrap: break-word;
					font-size: 16px;
					font-family: MicrosoftYaHei;
					text-align: left;
					line-height: 24px;
				}
			}

			.avatar {
				width: 50px;
				height: 50px;
				margin: 9px 0 0 15px;
				border-radius: 50%;
				object-fit: cover;
			}

			.flag {
				width: 20px;
				height: 15px;
				position: absolute;
				top: 5px;
				right: 20px;
				z-index: 100;
			}

			.Personal-info {
				margin-top: 15px;

			}



		}

		.item-tooltip {
			margin-top: 15px;

			.content-text {
				.icon {
					margin-right: 4px;
					vertical-align: middle;
				}
			}

			.rank {
				width: 70px;
				height: 18px;
				overflow-wrap: break-word;
				color: rgba(0, 0, 0, 1);
				font-size: 18px;
				font-family: MicrosoftYaHei;
				text-align: left;
				white-space: nowrap;
				line-height: 24px;
				margin-top: 3px;
			}

			.img-rank {
				background-color: rgba(236, 189, 99, 1);
				border-radius: 50%;
				height: 40px;
				width: 40px;
				margin-left: 112px;
			}

			.img-text {
				width: 20px;
				height: 15px;
				overflow-wrap: break-word;
				color: rgba(255, 255, 255, 1);
				font-size: 18px;
				font-family: MicrosoftYaHei;
				text-align: center;
				white-space: nowrap;
				line-height: 40px;
				margin-left: 9px;
			}

			.average-rods {
				color: #3B7544;
				margin-top: 10px;
				font-size: 18px;
			}
		}


	}

	.news {
		width: 45%;
		margin-left: 55px;

		.news-link {
			border-bottom: 3px solid #F5BB51;
			padding: 8px 0;

			.title {
				font-size: 18px;
				cursor: pointer;
			}

			.more {
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				cursor: pointer;
			}
		}

		.news-info {
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #000000;
			margin-top: 20px;

			.item-news {
				cursor: pointer;
				margin-bottom: 15px;
				display: block;
				letter-spacing: 1px;
			}
		}
	}



	.text-ellipsis1 {
		display: block;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.pagination {
		margin-top: 10px;

		span {
			display: block;
			padding: 10px;
			cursor: pointer;
			color: #999999;
		}

		.pagination-active {
			color: #3B7544;
			font-weight: 600;
		}
	}

	.winnerNo {
		width: 100%;
		margin-top: 35%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/deep/.pagination-container {
		padding: 0px !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/home/index.vue